import * as tslib_1 from "tslib";
import { FormControl, Validators, Validator, ValidationErrors } from '@angular/forms';
var CustomEmail = /** @class */ (function (_super) {
    tslib_1.__extends(CustomEmail, _super);
    function CustomEmail() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CustomEmail.validate = function (control) {
        if (control.value) {
            var matches = control.value.match(/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/);
            return matches ? null : { 'invalidEmail': true };
        }
        else {
            return null;
        }
    };
    return CustomEmail;
}(Validators));
export { CustomEmail };
var EmailValidatorDirective = /** @class */ (function () {
    function EmailValidatorDirective() {
    }
    EmailValidatorDirective.prototype.validate = function (control) {
        return CustomEmail.validate(control);
    };
    return EmailValidatorDirective;
}());
export { EmailValidatorDirective };
